function collectErrorText(error) {
  if (!error) return '';

  return [
    error.message,
    typeof error.body === 'string' ? error.body : error.body?.message,
    error.body?.error,
    error.response?.statusText,
    error.response?.data?.message,
  ].filter(value => typeof value === 'string').join(' ');
}

export function isWebserviceAuthorizationFailure(error) {
  if (!error) return false;

  const statusCodes = [
    error.status,
    error.statusCode,
    error.response?.status,
    error.body?.status,
    error.body?.statusCode,
  ];
  if (statusCodes.some(status => Number(status) === 401)) return true;

  const errorText = collectErrorText(error);
  return /\b(?:not authorized|unauthorized)\b/i.test(errorText)
    || /\b(?:invalid|expired)\b.{0,32}\b(?:session|token)\b/i.test(errorText)
    || /\b(?:session|token)\b.{0,32}\b(?:invalid|expired)\b/i.test(errorText);
}
